import api from '../utils/axiosConfig'
import type {
    OperationLogListResponse,
    OperationLogQueryParams,
} from '../types/operationLog'

export const getOperationLogs = async (
    params: OperationLogQueryParams,
): Promise<OperationLogListResponse> => {
    const response = await api.get<OperationLogListResponse>('/operation-logs', {
        params,
    })
    return response.data
}
